import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, ValidationErrors } from '@angular/forms';
import { Select, Store } from '@ngxs/store';
import { AccountActions, ModalOverlayRef, ModulesSelectors } from '@serviceos-ng/core';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';

@Component({
    selector: 'serviceos-web-account-deletion-modal',
    templateUrl: './account-deletion-modal.component.html',
    styleUrls: ['./account-deletion-modal.component.scss'],
})
export class AccountDeletionModalComponent implements OnInit {
	public accountDeletionForm: FormGroup;
	public formErrorMessage = '';
	public formCompleted = false;
	public successMessage: string | null = 'Success';

    @Select(ModulesSelectors.getComponentFromModule('account', 'deletion'))
    config$!: Observable<any>

    public config: any = null;

    constructor(
		private _fb: FormBuilder,
		private _store: Store,
		private modalRef: ModalOverlayRef
		) {
        this.config$.subscribe((config) => {
            if (config) {
                this.config = config;
            }
        });
        
		this.accountDeletionForm = this._fb.group(
            {
                reason: '',
                comment: '',
				password: ''
            },
            { validator: accountDeletionFormValidator }
        );
	}

    ngOnInit(): void {}

	/**
	 * Form submit handler
	 * @returns 
	 */
	public onFormSubmit(): void {
		if (this.accountDeletionForm.valid) {
			const parsedComment = `${this.accountDeletionForm.get('reason')?.value?.name}${this.accountDeletionForm.get('reason')?.value.requires_comment ? `: ${this.accountDeletionForm.get('comment')?.value}` : '' }`, 
				payload: any = {
					comment: parsedComment,
					password: this.accountDeletionForm.get('password')?.value
				};
	
			this._store
                .dispatch(new AccountActions.RequestDeleteAccount(payload))
                .pipe(
                    finalize(() => {
                        // this.showLoader = false;
                    })
                )
                .subscribe(
                    (res) => {
                        this.formCompleted = true;
						// this.successMessage = res.
                    },
                    (error) => {
                        this.formErrorMessage = error?.error[0]?.message;

						setTimeout(() => {
							try {
								const sidebarContentElement: HTMLElement | null = document.querySelector('.sidebar-modal .content');

								if (sidebarContentElement) sidebarContentElement.scrollTop = 0;
							} catch (err) {
								// selector didnt work
							}
						}, 1)
                    }
                );
		} else {
            const formControlsNames: Array<string> = Object.keys(
                this.accountDeletionForm.controls
            );

            // Manually trigger reactive form validation
            for (
                let formControlNameIndex = 0;
                formControlNameIndex < formControlsNames.length;
                formControlNameIndex++
            ) {
                const formControlName: string =
                    formControlsNames[formControlNameIndex];

                this.accountDeletionForm.controls[formControlName].markAsTouched();
                this.accountDeletionForm.controls[formControlName].markAsDirty();
            }
		}
	}

	/**
     * Handler for clicking success page confirm button
     */
     public onSuccessScreenConfirmation(): void {
        this.modalRef.close();
    }
}

function accountDeletionFormValidator(
    form: AbstractControl
): ValidationErrors | null {
    const reason = form.get('reason')?.value || null,
    	comment = form.get('comment')?.value || '',
    	password = form.get('password')?.value || '';

    if (reason && reason.requires_comment == false && password) {
        return null;
    }

    if (
        reason &&
        reason.requires_comment &&
        comment.replace(/\s/g, '').length &&
		password
    ) {
        return null;
    }

    if (reason == null && comment.replace(/\s/g, '').length && password) {
        return null;
    }

    return {
        formError: true,
    };
}